import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import EmailCodeFormContainer from '../../../../Containers/AdminContainer/EmailCodes/EmailCodeForm';
const EmailCodeFormScreen = () => {
  return <EmailCodeFormContainer />;
};

export default EmailCodeFormScreen;
